import type { LoadableType } from '@confluence/loadable';
import { LoadablePaint } from '@confluence/loadable';
import type { ADFRendererWithExtensionsProps } from '../src/ADFRendererWithExtensions.tsx';

export const ADFRendererWithExtensions: LoadableType<ADFRendererWithExtensionsProps> =
	LoadablePaint({
		loader: async () =>
			(
				await import(
					/* webpackChunkName: "loadable-ADFRendererWithExtensions" */ '../src/ADFRendererWithExtensions.tsx'
				)
			).ADFRendererWithExtensions,
	});
